import React, { useEffect, useState } from 'react'
import { Button, Form, Input, InputNumber, message, Modal, Upload } from "antd";
import { Card, Row, Col, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import "./reward.css";
import "./karma.css";
import Gigt from '../../assets/KarmaIcons/Gigt(2).png';
import BoltSvg from '../../assets/KarmaIcons/bolt';
import Service from '../../service';
import { useDispatch } from 'react-redux';
import { hideAuthLoader, showAuthLoader } from '../../appRedux/actions/Auth';
import TextArea from 'antd/lib/input/TextArea';

// const rewardsData = [
//   {
//     title: 'Work from Home Pass',
//     points: 100,
//     icon: <img src={ Home } alt='gift-img' />,
//     editbutton: <EditOutlined />,
//   },
//   {
//     title: 'Voucher (1000 INR)',
//     points: 100,
//     icon: <DollarOutlined className="reward-icon voucher" />,
//     editbutton: <EditOutlined />,
//   },
//   {
//     title: 'Late Arrival Pass',
//     points: 50,
//     icon: <ClockCircleOutlined className="reward-icon late" />,
//     editbutton: <EditOutlined />,
//   },
// ];

const Karmareward = () => {
  const [hovered, setHovered] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [addRewardModalOpen, setaddRewardModalOpen] = useState(false)
  const [karma_reward_singleData, setkarma_reward_singleData] = useState({})
  const [rEwardID, setREwardID] = useState(null);
  const [viewModal, setviewModal] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [seletctRewardId, setSeletctRewardId] = useState(null);
  const [seletctRewardImg, setSeletctRewardImg] = useState(null);
  const [selectedReward, setSelectedReward] = useState(null);


  const dispatch = useDispatch()
  const [rewardsData, setrewardsData] = useState([])
  const { Title, Text } = Typography;


  const handleUpload = ({ file }) => {
    setFileList([file]); // Replace previous file with the new one
  };


  // Handle Form Submission
  const handleOk = async () => {
    try {
      const values = await form.validateFields(); // Validate form fields
      if (fileList.length == 0) {
        return message.error('Please upload Image');

      }
      const formData = new FormData();
      formData.append("description", values.description);
      formData.append("Title", values.Title);
      formData.append("karma_amount", values.karma_amount);

      // Append file if selected
      if (fileList.length > 0) {
        formData.append("attachment", fileList[0].originFileObj); // File object
      }

      console.log("FormData:", formData);
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.add_karma_reward,
        body: formData,
      });

      if (response.status) {
        if (response.status === 403) {
          message.error(response.message);
        } else {
          dispatch(hideAuthLoader());
          get_karma_reward()
          message.success("Karma reward added successfully!");

          // Reset form only after successful submission
          form.resetFields();
          setFileList([]); // Clear file selection
          setaddRewardModalOpen(false); // Close modal if needed
          setREwardID(null)

        }
      }
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  };


  const get_karma_reward_Id = async (reward) => {
    try {
      setREwardID(reward)
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.get_karma_reward_Id + '/' + reward,
        // body: formData,
      });

      if (response.status) {
        if (response.status === 403) {
          message.error(response.message);
        } else {
          dispatch(hideAuthLoader());
          console.log(response, 'get_karma_reward_Id');


          setkarma_reward_singleData(response.data.data)
          form.setFieldsValue({
            Title: response.data.data.Title,
            description: response.data.data.description ? response.data.data.description : "No description available",
            karma_amount: response.data.data.karma_amount,
            reward_img: response.data.data.reward_img, // If you're handling file uploads, set fileList separately
          });

          message.success("Karma rewards fetched successfully");

          // Reset form only after successful submission
        }
      }
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  }

  console.log(karma_reward_singleData, 'karma_reward_singleData');

  const get_karma_reward = async () => {
    try {

      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.get_karma_reward,
        // body: formData,
      });

      if (response.status) {
        if (response.status === 403) {
          message.error(response.message);
        } else {
          dispatch(hideAuthLoader());
          setrewardsData(response.data.data)
          // message.success("Karma rewards fetched successfully");

          // Reset form only after successful submission
        }
      }
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  }

  const update_karma_reward_Id = async (rEwardID) => {
    try {
      const values = await form.validateFields(); // Validate form fields

      const formData = new FormData();
      formData.append("description", values.description);
      formData.append("Title", values.Title);
      formData.append("karma_amount", values.karma_amount);

      // Append file if selected
      if (fileList.length > 0) {
        formData.append("attachment", fileList[0].originFileObj); // File object
      }

      console.log("FormData:", formData);
      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.update_karma_reward_Id + '/' + rEwardID,
        body: formData,
      });

      if (response.status) {
        if (response.status === 403) {
          message.error(response.message);
        } else {
          dispatch(hideAuthLoader());
          get_karma_reward()
          message.success("Karma reward added successfully!");

          // Reset form only after successful submission
          form.resetFields();
          setFileList([]); // Clear file selection
          setaddRewardModalOpen(false); // Close modal if needed
          setREwardID(null)

        }
      }
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  }
  const delete_karma_reward_Id = async (reward) => {

    try {

      const response = await Service.makeAPICall({
        methodName: Service.deleteMethod,
        api_url: Service.delete_karma_reward_Id + '/' + reward,
        // body: formData,
      });

      if (response.status) {
        if (response.status === 403) {
          message.error(response.message);
        } else {
          dispatch(hideAuthLoader());
          setrewardsData(response.data.data)
          message.success("Karma rewards deleted successfully");

          // Reset form only after successful submission
        }
      }
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  }


  const karmaRewardCreate = async (id) => {
    try {

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.karmaRewardCreate,
        body: { reward_id: id },
      });

      if (response.status) {
        console.log(response.data, 'response.data', id,response.data.message);

        if (response.data.status == 400) {
          message.error(response.data.message);
        } else {
          dispatch(hideAuthLoader());
          handleModalClose()
          message.success('Reward redemption requested successfully');

          // setrewardsData(response.data.data)
          // message.success("Karma rewards fetched successfully");

          // Reset form only after successful submission
        }
      }
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  }

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSeletctRewardId(null)
    setSeletctRewardImg(null)
  };

  useEffect(() => {
    get_karma_reward()

  }, [])
  console.log('karma_reward', rewardsData);


  const karmaRewardCreateModal = (_id, reward_img, karma_amount, Title, description) => {
    setIsModalOpen(true);
    setSeletctRewardId(_id)
    setSeletctRewardImg(reward_img)
    setSelectedReward({ _id, reward_img, karma_amount, Title, description });
    form.setFieldsValue({
      reward_id: _id,
      reward_img: reward_img,
      karma_amount: karma_amount,
      Title: Title,
      description: description,
    });
  }
  return (
    <div className="rewards-container karma-wrapper">
      <Card className="rewards-header welcome-card">
        <div className="rewards-title-container">

          <h2 className="rewards-title"> <img src={ Gigt } alt='gift-img' /> Available Rewards</h2>
        </div>
        {/* <div className="rewards-button">
          <Button type='primary' className='rewards-btn' onClick={() => { setaddRewardModalOpen(true) }}> <PlusOutlined /> Add Reward</Button>
        </div> */}
      </Card>
      <Card className="stats-card">
        <Row className='rewards-row '>
          { rewardsData.length > 0 ? rewardsData.map((reward, index) => (
            <Col xs={ 24 } lg={ 8 } sm={ 12 } className="reward-wrapper " key={ index }>
              <Card
                key={ index }
                className="reward-card karma-stat-card"
                onMouseEnter={ () => setHoveredIndex(index) }
                onMouseLeave={ () => setHoveredIndex(null) }
              >
                {/* Edit button (Visible on hover) */ }
                {/* <div className='edit-button'>
              

                </div> */}
                {/* Reward Icon */ }
                <div className="reward-icon-container">
                  <img src={ `${process.env.REACT_APP_API_URL}/uploads/Waffle_reward-img/${reward.reward_img}` } alt='reward_img'
                    width={ 30 } height={ 30 } />
                  {/* { reward.reward_img } */ }

                </div>

                {/* Reward Title */ }
                <div className="reward-title">
                  <h2>
                    { reward.Title }
                  </h2>
                </div>

                {/* Points with lightning icon */ }
                <div className="points-container">
                  <span className="points-value"> <p>  { reward.karma_amount } </p></span>
                  <span role="img" aria-label="lightning" className="lightning-icon">
                    <BoltSvg />
                  </span>
                </div>

                {/* Redeem Button */ }
                <Button
                  type="primary"
                  size="middle"
                  className="redeem-button"
                  onClick={ () => {
                    karmaRewardCreateModal(reward._id, reward.reward_img, reward.karma_amount, reward.Title, reward.description
                    )
                  } }

                >
                  Redeem
                </Button>
              </Card>
            </Col>
          )) : <div>No Rewards Available</div> }
        </Row>
      </Card>
      <Modal
        className='redeem-modal'
        title={ `${rEwardID ? 'Update Waffle Reward' : 'Add Waffle Reward'}` }
        open={ addRewardModalOpen }
        onCancel={ () => {
          setaddRewardModalOpen(false);
          setREwardID(null)

          form.resetFields();
        } }
        footer={ false }
      >
        <Form form={ form } layout="vertical" onFinish={ handleOk }>
          {/* Title */ }
          <Form.Item
            name="Title"
            label="Title"
            rules={ [{ required: true, message: "Please enter the title" }] }
          >
            <Input placeholder="Enter title" />
          </Form.Item>

          {/* Description */ }
          <Form.Item
            name="description"
            label="Description"
            rules={ [{ required: true, message: "Please enter the description" }] }
          >
            <Input.TextArea placeholder="Enter description" rows={ 3 } />
          </Form.Item>

          {/* Karma Amount */ }
          <Form.Item
            name="karma_amount"
            label="Karma Amount"
            rules={ [{ required: true, message: "Please enter karma amount" }] }
          >
            <InputNumber min={ 1 } style={ { width: "100%" } } placeholder="Enter karma amount" />
          </Form.Item>

          {/* Upload Image */ }
          <Form.Item label="Reward Image" name="reward_img" required={ !rEwardID }>
            <Upload
              beforeUpload={ () => false } // Prevent auto upload
              fileList={ fileList }
              onChange={ handleUpload }
              accept=".png,.jpg,.jpeg"
              maxCount={ 1 }
            >
              <Button icon={ <UploadOutlined /> }>Upload Image</Button>
            </Upload>

            {/* Show error message if no file is selected */ }
            {/* {fileList.length === 0 && (
            <div style={{ color: "red", marginTop: 4 }}>Please upload an image</div>
          )} */}

            {/* Show Selected Files Below */ }

          </Form.Item>
          <Form.Item>

            { rEwardID ? <Button type='primary' onClick={ () => { update_karma_reward_Id(rEwardID) } }>Update Reward</Button> : <Button type='primary' htmlType="submit">Add Reward</Button> }
            <Button type='text' htmlType="submit" className='delete-btn' onClick={ () => {
              setaddRewardModalOpen(false);
              setREwardID(null)

              form.resetFields();
            } }
            > Cancel</Button>



          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Reward Description"
        open={ viewModal }
        onCancel={ () => { setviewModal(false) } }
        footer={ false }
      >
        <Form form={ form } layout="vertical">
          <Form.Item label="Description" name="description">
            <TextArea rows={ 4 } disabled />
          </Form.Item>
        </Form>  {/*  */ }

      </Modal>




      {/* //// */ }
      <Modal
        className='redeem-modal'
        title="Redeem Reward"
        open={ isModalOpen }
        onCancel={ handleModalClose }
        footer={ null }
      >
        <Form
          form={ form }
          layout="vertical"
        // onFinish={(values) => {
        //   console.log("Redeem Data:", { ...values, reward_id: selectedReward._id });
        //   handleModalClose(); // Close modal after submission
        // }}
        >
          {/* Reward Image */ }
          <Row gutter={ 24 }>
            <Col sm={ 24 } >

              <div className="reward-icon-container">
                <img
                  src={ `${process.env.REACT_APP_API_URL}/uploads/karma_reward-img/${seletctRewardImg}` }
                  alt="reward_img"
                  width={ 30 }
                  height={ 30 }
                />
              </div>
              <div className='karma-redeem-total'> <span>Amount :</span> { selectedReward?.karma_amount }</div>
            </Col>
            <Col sm={ 24 } >
              {/* Reward Title */ }
              <div className='redeem-modal-title'> <h4>{ selectedReward?.Title }</h4></div>
              <div className='redeem-modal-description'> <p>{ selectedReward?.description }</p></div>

            </Col>
          </Row>



          <Row>


            <Col sm={ 24 } justify="center" align="center">
              <Button key="redeem" type="primary" className="redeem-button" onClick={()=>{karmaRewardCreate(seletctRewardId)}}
              >
                Confirm Redeem
              </Button>
            </Col>
          </Row>



          {/* Additional Form Fields */ }

        </Form>

      </Modal>

    </div>
  )
}

export default Karmareward